import checkDiagram from "../../public/images/check-diagram.png";
import pure from "./higher-order/pure";
import HelpBox from "./help-box";
import React from "react";

export default pure(function AchHelp({ onClose }) {
  return (
    <HelpBox onClose={onClose}>
      <h3>
        What&apos;s the difference between a Routing Number and an Account Number?
      </h3>

      <p className="text-center">
        <img src={checkDiagram} />
      </p>
    </HelpBox>
  );
});
